<template>
<div>
  <el-card body-style="padding: 0" >
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">我的邀请码</span>
    </div>
  </el-card>
  <el-card style="margin-top: 2%;" v-show="isShowCustomerOrBusiness==1 || isShowCustomerOrBusiness == 3">
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">商家推广邀请<span style="color: red;">(我的邀请码：{{shareCode}})</span></span>
    </div>
    <div>
      <el-input readonly type="textarea" v-model="businessShareCode"></el-input>
    </div>
  </el-card>
  <el-card style="margin-top: 2%;" v-show="false&&(isShowCustomerOrBusiness==1||isShowCustomerOrBusiness==2)">
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">试客推广邀请</span>
    </div>
    <div>
      <el-input readonly type="textarea" v-model="customerShareCode"></el-input>
    </div>
  </el-card>
</div>
</template>

<script>
import {queryShareCode} from "../../api/b2cbusiness/b2c_sharecode";
import {getCommission} from "../../api/b2cbusiness/storelist";

export default {
name: "MyShareCode",
  data() {
    return {
      isShowCustomerOrBusiness:1,
      shareCode:"",
      //businessShareCode:"https://api.weiquanai.com/register?sharecode=",
      businessShareCode:"http://"+window.location.hostname+"/register?sharecode=",
      customerShareCode:"[推客商城]欢迎您来到推客商城，注册时记得填邀请码:"
    }
  },
  mounted() {
  getCommission({businessId:null}).then(res=>{
    if (res.success){
      this.isShowCustomerOrBusiness = res.data.shareLimit;
    }
  })
  this.getData();
  },
  methods:{
  getData(){
    queryShareCode().then(res=>{
      if (res.success){
        this.shareCode = res.data;
        if (window.location.hostname == 'dl.usmartdoc.com'){
          this.businessShareCode = "http://sj.usmartdoc.com/register?sharecode="
        }
        this.businessShareCode = this.businessShareCode + this.shareCode;
        this.customerShareCode = this.customerShareCode + this.shareCode + "。请点击或复制链接: http://"+window.location.hostname+"/customer/register?sharecode= "+this.shareCode +" 到浏览器打开注册";
        //this.customerShareCode = this.customerShareCode + this.shareCode + "。请点击或复制链接 https://api.weiquanai.com/register?sharecode= "+this.shareCode +" 到浏览器打开注册";
      }
    });
  }
  }
}
</script>

<style scoped>

</style>
